<template>
  <div class="pkg-content" v-loading="dataListLoading">
    <el-row>
      <el-col :span="24" align="right">
        <el-button type="primary" @click="handleSave" v-if="type !== 'view'"
          >{{ $t("save") }}
        </el-button>
        <el-button type="primary" @click="handleBack"
          >{{ $t("user.back") }}
        </el-button>
      </el-col>
    </el-row>
    <div class="divider" />

    <el-form
      class="pkg-content"
      label-width="auto"
      label-position="top"
      :model="dataForm"
      :rules="rules"
      ref="dataForm"
    >
      <el-row class="margb10" :gutter="30">
        <el-col :span="6">
          <el-form-item prop="ruleName" label="规则名称">
            <el-input
              maxlength="50"
              :disabled="type === 'view'"
              v-model="dataForm.ruleName"
              :placeholder="$t('请输入')+'最大50字符'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col v-if="this.type !== 'new'" :span="6">
          <el-form-item prop="versionNo" label="当前版本号">
            <el-input
              disabled
              v-model="dataForm.versionNo"
              :placeholder="$t('请输入')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="status" label="规则状态">
            <el-select
              v-model="dataForm.status"
              clearable
              placeholder="请选择"
              :disabled="dataForm.initStatus=== '0'||type === 'view'"
            >
              <el-option
                v-for="item in state"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item prop="priorityLevel" label="减免顺序">
            <el-input
              maxlength="5"
              :disabled="type === 'view' || dataForm.status === '0'"
              :placeholder="type === 'view' || dataForm.status === '0' ? '' : $t('请输入')+'最大5位正整数'"
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
              v-model.number="dataForm.priorityLevel"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10" :gutter="30">
        <el-col :span="24">
          <el-form-item prop="ruleDesc" label="规则描述">
            <el-input
              style="width:100%"
              :disabled="type === 'view'"
              type="textarea"
              v-model="dataForm.ruleDesc"
              :placeholder="type === 'view' ? '' : $t('请输入')+'最大1000字符'"
              maxlength="1000"
              show-word-limit
              :rows="5"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="margin-top: 20px;">
        <!-- 新增 btnAdded -->
        <el-button v-if="type!=='view'" type="primary" @click="handleExport">模板下载 </el-button>

        <el-button v-if="type!=='view'" type="primary" @click="handleImport">导入
          <el-tooltip
            class="item"
            effect="dark"
            content="导入只支持Excel格式文件，最大10M"
            placement="top"
          >
            <em style="color:#fff;" class="el-icon-question"></em>
          </el-tooltip></el-button>
        <el-button v-if="type==='view'" type="primary" @click="handleExport">导出 </el-button>
      </div>
    </el-form>

    <el-table
      v-loading="dataListLoading"
      ref="multipleTable"
      :data="tablePagingData"
      border
      :row-style="{ height: 48 + 'px' }"
      :cell-style="{ padding: 0 + 'px' }"
    >
      <el-table-column
        prop="orgCategoryNo"
        label="组织类别编号"
        header-align="center"
        align="center"
        min-width="160"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <!--组织类别名称-->
      <el-table-column
        prop="orgCategoryName"
        label="组织类别名称"
        header-align="center"
        align="left"
        :show-overflow-tooltip="true"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-link
          @click="gotoOrganization(scope.row)"
          type="primary"
          :underline="false"> {{scope.row.orgCategoryName}}</el-link>
        </template>
      </el-table-column>

      <!--组群代码-->
      <el-table-column
        label="组群代码"
        prop="groupNo"
        header-align="center"
        align="left"
        :show-overflow-tooltip="true"
        min-width="120"
      ></el-table-column>
      <!-- 组群名称 -->
      <el-table-column
        prop="groupName"
        label="组群名称"
        header-align="center"
        min-width="120"
        align="left"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <!-- 规则最后修改人 -->
      <!-- <el-table-column
        prop="updateUser"
        label="规则最后修改人"
        header-align="center"
        align="center"
        min-width="120"
        :show-overflow-tooltip="true"
      ></el-table-column> -->
      <!-- 课程分类一 -->
      <el-table-column
        prop="courseCatalogOne"
        label="课程分类一"
        header-align="center"
        min-width="120"
        :show-overflow-tooltip="true"
        align="center"
      ></el-table-column>
      <!-- 课程分类二 -->
      <el-table-column
        prop="courseCatalogTwo"
        label="课程分类二"
        header-align="center"
        min-width="120"
        :show-overflow-tooltip="true"
        align="center"
      ></el-table-column>
      <!-- 课程代码 -->
      <el-table-column
        prop="courseCode"
        label="课程代码"
        header-align="center"
        align="left"
        min-width="120"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <!-- 课程名称 -->
      <el-table-column
        prop="courseName"
        label="课程名称"
        header-align="center"
        align="left"
        min-width="120"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <!-- 课程类型 -->
      <el-table-column
        prop="courseType"
        label="课程类型"
        header-align="center"
        align="left"
        min-width="120"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <!-- 规则开始时间 -->
      <el-table-column
        prop="freeDateS"
        label="规则开始时间"
        header-align="center"
        align="left"
        min-width="180"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.freeDateS ? scope.row.freeDateS.split(" ")[0] : '' }}
          </div>
        </template>
      </el-table-column>
      <!-- 规则结束时间 -->
      <el-table-column
        prop="freeDateE"
        label="规则结束时间"
        header-align="center"
        align="left"
        min-width="180"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.freeDateE ? scope.row.freeDateE.split(" ")[0] : '' }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="tablePaging.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="tablePaging.pageSize"
      :total="dataForm.freeRulesRecordDTOList.length"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>


    <import-excel
      v-bind:visible="dialogVisible"
      v-bind:url="uploadUrl"
      v-on:closeDialogImport="dialogVisible = false"
      @getData="getData"
    ></import-excel>
  </div>
</template>

<script>
// import mixinViewModule from "@/mixins/view-module";
import importExcel from "@/views/modules/charge/organizationCategory/components/import";
import qs from 'qs'
import {log} from "fullcalendar";

export default {
  name: "",
  components: {
    importExcel,
  },
  // mixins: [mixinViewModule],
  data() {
    let _this = this;
    return {
      dataListLoading: false,
      tablePaging: {
        pageNum: 1,
        pageSize: 10,
        data: [],
      },
      initialPriorityLevel: '',
      dataForm: {
        ruleName: '',
        versionNo: '',
        status: '',
        priorityLevel: '',
        ruleDesc: '',
        freeRulesRecordDTOList: [],
        initStatus: ''
      },
      state: [
        {
          value: "1",
          label: "活动",
        },
        {
          value: "0",
          label: "不活动",
        },
      ],
      dialogVisible: false,
      uploadUrl: "/learning/rule/freerulesrecord/importExcel",
      type: "",
      isNow: false,
    };
  },
  // 计算属性
  computed: {
    rules() {
      if (this.dataForm.status === "1") {
        this.dataForm.priorityLevel = this.initialPriorityLevel;
        return {
          ruleName: [
            { required: true, message: "请输入规则名称", trigger: "blur" },
          ],
          status: [
            { required: true, message: "请选择规则状态", trigger: "blur" },
          ],
          priorityLevel: [
            { required: true, message: "请输入减免顺序", trigger: "change" },
            {
              pattern: /^[1-9][0-9]*$/,
              message: "只能输入正整数",
            },
          ],
        }
      } else {
        this.dataForm.priorityLevel = '';
        this.$nextTick(() => {
          let af = this.$refs['dataForm']
          if(af){
            af.clearValidate()
          }
        })
        return {
          ruleName: [
            { required: true, message: "请输入规则名称", trigger: "blur" },
          ],
          status: [
            { required: true, message: "请选择规则状态", trigger: "blur" },
          ],
        }
      }


    },
    // 表格分页
    tablePagingData() {
      let start = (this.tablePaging.pageNum - 1) * this.tablePaging.pageSize;
      let end = this.tablePaging.pageNum * this.tablePaging.pageSize;
      return this.dataForm.freeRulesRecordDTOList.slice(start, end);
    },
  },
  watch: {},
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.type = this.$route.params.type;
    this.isNow = this.$route.params.isNow;
    this.initMethod();
    this.dataForm = JSON.parse(JSON.stringify(this.dataForm));
    if (this.type === "view") {
      this.$eventHub.$on("eightDimensionsView", (data) => {
        this.initMethod();
        // this.$refs.dataForm.clearValidate();
      });
    } else if (this.type === "edit") {
      this.$eventHub.$on("eightDimensionsEdit", (data) => {
        this.initMethod();
        // this.$refs.dataForm.clearValidate();
      });
    } else if (this.type === "new") {
      this.$eventHub.$on("eightDimensionsNew", (data) => {
        this.initMethod();
        // this.$refs.dataForm.clearValidate();
      });
    }
  },
  destroyed() {
    this.$eventHub.$off("eightDimensionsNew");
    this.$eventHub.$off("eightDimensionsEdit");
    this.$eventHub.$off("eightDimensionsView");
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    console.log('mounted')
  },
  methods: {
    // 跳转组织类别
    gotoOrganization(row) {
      this.dataListLoading = true;
      this.$request
        .get(`/learning/rule/orgcategory/getHis`, {
          id: row.orgCategoryId,
          versionNo: row.categoryVersionNo,
        })
        .then((data) => {
          this.dataListLoading = false;
          if (data && data.length > 0) {
            this.$router.push({
              name: "organizationCategoryView",
              params: {
                type: "view",
                id: data[0].edition === 1 ? row.orgCategoryId : data[0].id,
                downloadId: row.orgCategoryId,
                isNow: data[0].edition === 1,
              },
            });
            this.$eventHub.$emit("organizationCategoryView", "activated");
          }
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    initMethod() {
      if (this.type !== "new") {
        if (this.$route.params) {
          this.dataForm.id = this.$route.params.id;
          this.getInfo();
        }
      }
    },
    // 获取信息
    getInfo() {
      this.dataListLoading = true;
      if (this.isNow) {
        this.$request
          .get(`/learning/rule/freerules/${this.dataForm.id}`)
          .then((data) => {
            this.dataForm = JSON.parse(JSON.stringify(data));
            this.initialPriorityLevel = this.dataForm.priorityLevel;
            this.dataForm.initStatus=this.dataForm.status;
            this.dataListLoading = false;
          })
          .catch(() => {
            this.dataListLoading = false;
          });
      } else {
        this.$request
          .get(`/learning/rule/freeruleshis/${this.dataForm.id}`)
          .then((data) => {
            this.dataForm = JSON.parse(JSON.stringify(data));
            this.dataForm.freeRulesRecordDTOList = this.dataForm.freeRulesRecordHisDTOList;
            this.initialPriorityLevel = this.dataForm.priorityLevel;
            this.dataForm.initStatus=this.dataForm.status;
            this.dataListLoading = false;
          })
          .catch(() => {
            this.dataListLoading = false;
          });
      }
    },
    handleSave() {
      this.$refs["dataForm"].validate((valid) => {
          if (this.tablePagingData.length === 0) {
            return this.$message({
              message: "请导入培训减免规则明细",
              type: "error",
              duration: 2000,
            });
          }
          if (valid) {
            this.$confirm('是否保存为新版本?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.dataListLoading = true;
              let url = "/learning/rule/freerules";
              let method = this.type === "new" ? "post":"put";
                this.$request[method](url, this.dataForm)
                  .then((data) => {
                    this.$message({
                      message: this.$t("prompt.success"),
                      type: "success",
                      duration: 500,
                      onClose: () => {
                        this.dataListLoading = false;
                        this.tabRemove(this.$store.state.contentTabsActiveName);
                      },
                    });
                  })
                  .catch(() => {
                    this.dataListLoading = false;
                  });
            }).catch((err) => {
              console.log(err)
            })
          }
        });
    },
    handleBack() {
      this.$router.push({
        name: "charge-eightDimensions-index",
        params: {},
      });
    },
    handleExport() {
      this.dataListLoading = true;
      // download 参数 url, params, 报表名
      if (this.isNow) {
        if (this.type === "view") {
          let temp = {
            ruleName: this.dataForm.ruleName, //规则名称
            ruleCreateUser: this.dataForm.ruleCreateUser, //规则创始人
            ruleUpdateUser: this.dataForm.ruleUpdateUser, //规则最后跟新人
            status: this.dataForm.status, //规则状态

          };
          var params = qs.stringify({
            'token': this.getStorage(this.GLOBAL.TOKEN),
            ...temp
          })
          window.location.href = `${window.SITE_CONFIG['apiURL']}/learning/rule/freerules/export?${params}`
          this.dataListLoading = false;
        } else {
          this.$request
            .loadingDownload(
              `/learning/rule/freerulesrecord/export?id=${
                this.type === "new" ? -1 : this.dataForm.id
              }`,
              this.type === "view" ? "培训辅导减免规则" : "培训辅导减免规则导入模板"
            )
            .then((data) => {
              this.dataListLoading = data;
            }).catch(() => {
              this.dataListLoading = false;
            });
        }
      } else {
        this.$request
          .loadingDownload(
            `/learning/rule/freerulesrecordhis/export?id=${
              this.type === "new" ? -1 : this.dataForm.id
            }&versionNo=${this.dataForm.versionNo}`,
            this.type === "view" ? "培训辅导减免规则" : "培训辅导减免规则导入模板"
          )
          .then((data) => {
            this.dataListLoading = data;
          }).catch(() => {
            this.dataListLoading = false;
          });
      }
    },
    // 导入完成后，组件回调数据
    getData(data) {
      console.log(data);
      this.dataForm.freeRulesRecordDTOList = data;
    },
    handleImport() {
      this.dialogVisible = true;
    },
    // handleDialogImport() {},
    // // 上传成功
    // handleSuccess(response, file, fileList) {
    //   this.fileList = [];
    //   this.getDataList();
    // },
    // beforeExcelUpload(file, fileList) {
    //   let maxLength = 20 * 1024 * 1024;
    //   if (file.size > maxLength) {
    //     this.$message({
    //       message: "文件大小不能超过20M",
    //       type: "error",
    //       duration: 1500,
    //       onClose: () => {
    //         this.getDataList();
    //       },
    //     });
    //     return false;
    //   }
    //   return true;
    // },
    tabRemove(tabName) {
      if (tabName === "home") {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      );
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
          "home";
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          path: "/manage/charge-eightDimensions-index",
        });
      }
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.tablePaging.pageNum = 1;
      this.tablePaging.pageSize = val;
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.tablePaging.pageNum = val;
    },
  },
};
</script>

<style rel="stylesheet/scss" scoped lang="scss">
@import "../../../css/pkg-styles.css";
.divider {
  display: block;
  height: 2px;
  width: 100%;
  margin: 24px 0;
  background-color: #a2a2a2;
  position: relative;
}

 .el-form-item {
  width: 100% !important;
}
.margb10 {
  min-height: 75px;
}
</style>
